import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import RangeSliderProps from './RangeSliderProps'

import Tooltip from '../Common/Tooltip'

export default {
    template: '<div><input :name="selectionStartName" /><input :name="selectionEndName" /></div>',
    props: RangeSliderProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Tooltip
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoRangeSlider(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function () {
            that.$emit('changemodel', that.kendoWidget().value())
        })

        that.kendoWidget().bind('slide', function () {
            that.$emit('changemodel', that.kendoWidget().value())
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoRangeSlider()
        }
    },
    computed: {
        nameAttr() {
            return this.$attrs.name
        },
        selectionStartName() {
            var nameAttr = this.nameAttr
            return nameAttr ? nameAttr + '[0]' : null
        },
        selectionEndName() {
            var nameAttr = this.nameAttr
            return nameAttr ? nameAttr + '[1]' : null
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoRangeSlider/KendoRangeSliderMixin.js